


















import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class ProjectMemberCard extends Vue {
  @Prop({ default: "" }) name!: string;
  @Prop({ default: "" }) icon!: string;
  @Prop({ default: "" }) belongsTo!: string;
}
